/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCfnTemplateExecution extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCfnTemplateExecution");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCfnTemplateExecution.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCfnTemplateExecution>): BackgroundJobPayloadForCfnTemplateExecution {
        let obj = Object.assign(new BackgroundJobPayloadForCfnTemplateExecution(), model);
        BackgroundJobPayloadForCfnTemplateExecution.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCfnTemplateExecution>): BackgroundJobPayloadForCfnTemplateExecution {
        if (!model) return null;
        return BackgroundJobPayloadForCfnTemplateExecution.newInstance(<BackgroundJobPayloadForCfnTemplateExecution> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCfnTemplateExecution) {
        if (!obj) return;

        models.BackgroundJobPayloadForCfnTemplateExecution.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCfnTemplateExecution): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCfnTemplateExecution.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    job_id: string;

    notification_email_id: string;

    /**
     * parameters to template
     */
    execution_params: any;

}
